import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const FetchTopics = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAccessTokenSilently } = useAuth0();

  const renderTopicsTable = (topics) => {
    return (
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Id</th>
            <th>GroupId</th>
            <th>Title</th>
            <th>Body</th>
            <th>PostDate</th>
            <th>UserId</th>
            <th>Public</th>
            <th>CreatedOn</th>
          </tr>
        </thead>
        <tbody>
          {topics.map(topic =>
            <tr key={topic.id}>
              <td>{topic.id}</td>
              <td>{topic.groupId}</td>
              <td>{topic.title}</td>
              <td>{topic.body}</td>
              <td>{topic.postDate}</td>
              <td>{topic.userId}</td>
              <td>{topic.public}</td>
              <td>{topic.createdOn}</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    const populateTopicsData = async () => {
    const token =  await getAccessTokenSilently({
        authorizationParams: {
                audience: process.env.REACT_APP_API_AUDIENCE,
            }
    });  
    const response = await fetch('api/topics',{
            headers: {
                Authorization: `Bearer ${token}`,
              },
            });
      const data = await response.json();
      setTopics(data);
      setLoading(false);
    };
    populateTopicsData();
  }, [getAccessTokenSilently]);

  const contents = loading
    ? <p><em>Loading...</em></p>
    : renderTopicsTable(topics);

  return (
    <div>
      <h1 id="tabelLabel">Topics</h1>
      <p>This component demonstrates fetching data from the server.</p>
      {contents}
    </div>
  );
};
